import { FC } from 'react';

import { GiftPage } from '@bpm-web-app/components/src/lib/supreme-account/gifts/gift';
import { AccountPageProps } from '@bpm-web-app/components/src/lib/supreme-account/account';

export const AccountGiftPage: FC<AccountPageProps> = (props) => <GiftPage {...props} />;

export default AccountGiftPage;
